<template>
  <slider-layout is-show-overlay gray-bg>
      <div class="col-lg-10 ml-auto mr-auto mt-3">
              <card>
                <!-- <button
                  type="button"
                  class="pull-right close"
                  @click="$router.push('/home')"
                >
                  X
                </button> -->

                <h4 class="header text-center">
                  광고주/대행사 소속 담당자 비밀번호 초기화
                </h4>
                <hr class="mb-4" />
                <el-form
                  @submit.native.prevent="submitForm('ruleForm')"
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="160px"
                  class="mr-5"
                >
                  <p class="mb-4 fs15 text-primary2" style="margin-left: 135px">
                      회원가입 시 입력하셨던 e-mail 주소로 초기화된 비밀번호가 전송됩니다.
                  </p>
                  <el-form-item label="광고주" prop="companySeq" required>
                    <el-row :gutter="12">
                      <div v-disabled-fieldset="confirmLicens">
                        <search-company
                          cls="pl-0"
                          v-model="ruleForm.companySeq"
                          :is-user-company="true"
                          :keyword-span="5"
                          :company-span="12"
                          :showLabel="false"
                          @selected="companySelected"
                        >
                        </search-company>
                      </div>
                    </el-row>
                  </el-form-item>

                  <div v-disabled-fieldset="!ruleForm.companySeq || confirmLicens">
                    <el-form-item label="사업자 등록번호" prop="sabun"  required>
                      <!-- <span class="text-primary2 fs18 ml-3">{{licenseNumber.substring(0,5) + '*****'}}</span> -->
                      <!-- <el-col :span="3" class="text-danger" >(직접입력)</el-col> -->
                      <sabun-input v-model="ruleForm.sabun"></sabun-input>
                      <el-col :span="4" v-if="!confirmLicens">
                        <el-button
                          class="ml-3"
                          type="danger"
                          @click="checkSabun"
                          size="sm"
                          >번호확인</el-button
                        >
                      </el-col>
                      <el-col
                        :span="4"
                        v-if="confirmLicens"
                        class="ml-2 text-primary2 fs15"
                      >
                        정보일치
                      </el-col>
                    </el-form-item>
                  </div>

                  <hr class="" />

                  <div v-disabled-fieldset="!confirmLicens">
                    <el-form-item label="아이디 (이메일)" required>
                      <el-col :span="6">
                        <el-form-item prop="emailId">
                          <el-input v-model="ruleForm.emailId"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="text-center" :span="2">@</el-col>
                      <el-col :span="6">
                        <el-form-item prop="emailDomain">
                          <el-input v-model="ruleForm.emailDomain"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-form-item>

                    <el-form-item label="담당자 성명" prop="userName" required>
                      <el-input v-model="ruleForm.userName"></el-input>
                    </el-form-item>

                    <el-form-item label="휴대폰" prop="phone" required>
                      <tel-input v-model="ruleForm.phone"></tel-input>
                    </el-form-item>

                    <el-form-item label="보안문자" prop="captcha" required>
                      <el-input
                        v-model="ruleForm.captcha"
                        style="width: 120px"
                      ></el-input>
                      <img class="ml-3" :src="captcha" />
                      <el-button @click="changeCaptchaUrl" class="ml-2" size="mini" round
                        ><i class="el-icon-refresh"></i> 새로고침</el-button
                      >
                    </el-form-item>

                    <el-form-item class="text-right mt-5">
                      <el-button native-type="submit" type="primary" icon="el-icon-lock"
                        >비밀번호 초기화</el-button
                      >
                      <el-button @click="$router.push('/home')" icon="el-icon-house"
                        >메인으로 이동</el-button
                      >
                    </el-form-item>
                  </div>
                </el-form>
              </card>
            </div>
  </slider-layout>
</template> 
<script>
import AppFooter from "src/components/Pages/Views/Layout/AppFooter";
import SearchCompany from "@/components/Pages/Views/Common/SearchCompany.vue";
import CommonProxy from "@/proxies/CommonProxy";
import TelInput from '@/components/Pages/Views/Common/TelInput.vue'
import SabunInput from '@/components/Pages/Views/Common/SabunInput.vue';
import * as Util from "@/util/util";
import _ from "lodash";
import SliderLayout from './Layout/SliderLayout.vue';

const validator = (
  { required, onlyWord, domain, min, confirmPassword, phone, captcha },
  vm
) => {
  return (rule, value, callback) => {
    if (required && !value) {
      callback(new Error("필수입력 항목입니다."));
      return;
    } else if (onlyWord && !/^[\w\-\.]+$/g.test(value)) {
      callback(new Error("영문만 가능합니다."));
      return;
    } else if (domain && !/[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value)) {
      callback(new Error("이메일 형식만 가능합니다. ex)gmail.com"));
      return;
    } else if (min && value.length < min) {
      callback(new Error(`최소 ${min}자리 이상 이어야 합니다.`));
      return;
    } else if (confirmPassword && value !== vm.ruleForm[confirmPassword]) {
      callback(new Error("비밀번호가 일치하지 않습니다."));
      return;
    } else if (phone && !/^[\d\-]+$/g.test(value)) {
      callback(new Error("숫자 또는 -(하이픈)만 가능합니다."));
      return;
    } else if (captcha) {
      vm.debouncedCaptchaAnswer(value, callback);
    } else {
      callback();
    }
  };
};

export default {
  components: {
    AppFooter,
    SearchCompany,
    TelInput,
    SabunInput, SliderLayout
  },
  created() {
    this.debouncedCaptchaAnswer = _.debounce(this.capchaValid, 800);
  },
  methods: {
    checkSabun() {

      if(!this.ruleForm.sabun) {
        alert('사업자등록번호를 입력해 주세요')
        return
      }
      // 2128127329
      new CommonProxy()
      .validLicense( this.ruleForm.companySeq, this.ruleForm.sabun)
      .then(response => {
        if(!response.success) {
          alert('사업자등록번호가 일치하지 않습니다.\n다시 확인하시기 바랍니다.')
        } else {
          alert('사업자등록번호가 확인 되었습니다.\n비밀번호초기화에 필요한 항목들을 입력해 주세요.')
          this.confirmLicens = true

        }
      })

    },
    capchaValid(value, callback) {
      new CommonProxy().validCaptcha(value).then((response) => {
        if (!response.success) {
          callback(new Error("보안문자가 일치하지 않습니다."));
        } else {
          callback();
        }
      });
    },
    companySelected({ licenseNumber }) {
      this.licenseNumber = licenseNumber;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          new CommonProxy().resetPwd(this.ruleForm).then((response) => {
            this.idSuccess = response.success;
            if (!response.success) {
              alert("해당하는 정보를 찾을 수 없습니다.");
            } else {
              alert("가입 되어있는 이메일로 전송했습니다.\n메일을 확인하세요.");
              this.$router.push("/home");
            }
          }).finally(()=> this.changeCaptchaUrl())

        } else {
          alert("회원정보 및 보안문자를 올바르게 입력해주세요");
          return false;
        }
      });
    },
    changeCaptchaUrl() {
      this.captcha = "/api/common/captcha" + "?" + Util.random(1, 10000);
      return this.captcha;
    },
    setEmail() {
      this.ruleForm.email = this.ruleForm.emailId + "@" + this.ruleForm.emailDomain;
      this.ruleForm.userId = this.ruleForm.email;
    },
  },
  watch: {
    "ruleForm.emailId": {
      deep: true,
      handler() {
        this.setEmail();
      },
    },
    "ruleForm.emailDomain": {
      deep: true,
      handler() {
        this.setEmail();
      },
    },
  },
  data() {
    return {
      captcha: this.changeCaptchaUrl(),
      confirmLicens: false,
      idSuccess: undefined,
      licenseNumber: "",
      userId: "",
      ruleForm: {
        companySeq: "",
        userId: "",
        emailId: "",
        emailDomain: "",
        email: "",
        userName: "",
        phone: "",
        captcha: "",
      },
      rules: {
        companySeq: [{ trigger: "change", validator: validator({ required: true }) }],
        userName: [
          { trigger: "blur", validator: validator({ required: true }) },
          { trigger: "change", validator: validator({ required: true }) },
        ],
        emailId: [
          { trigger: "blur", validator: validator({ required: true, onlyWord: true }) },
          { trigger: "change", validator: validator({ required: true, onlyWord: true }) },
        ],
        emailDomain: [
          { trigger: "blur", validator: validator({ required: true, domain: true }) },
          { trigger: "change", validator: validator({ required: true, domain: true }) },
        ],
        phone: [
          { trigger: "change", validator: validator({ required: true, phone: true }) },
          { trigger: "blur", validator: validator({ required: true, phone: true }) },
        ],
        captcha: [
          {
            trigger: "change",
            validator: validator({ required: true, captcha: true }, this),
          },
          {
            trigger: "blur",
            validator: validator({ required: true, captcha: true }, this),
          },
        ],
        sabun: [
            { trigger: 'input', validator: validator({ required: true}) },
            { trigger: 'blur', validator: validator({ required: true}) }
         ],      
      },
    };
  },
};
</script>
<style>
.join-page {
  background-image: url(/static/commons/images/main_bg.jpg);
  min-height: 100vh;
  background-size: cover;
}
.join-page .logo {
  width: 221px;
  height: 64px;
  background: url("/static/commons/images/main_logo.png") no-repeat;
  margin: 0 auto;
  position: absolute;
  background-size: contain;
  z-index: 1000;
  margin: 30px;
}

.join-page .card label {
  color: #606266;
  font-size: 14px;
}
</style>
